import React, { Dispatch, SetStateAction } from 'react';

import { SpaceBetween, ColumnLayout, MultiselectProps } from '@amzn/awsui-components-react-v3';

import Tags from 'src/components/Tags';
import { Model } from 'src/store/types';

import { BuildCategory } from './BuildCategory';
import { BuildIDComponent } from './BuildId';
import { APNCellDefinition, MPNIPNDefinition } from './MPNCell';
import { MPNExecutionCell } from './MPNExecutionCell';
import { ExpectedReceivedQuanity, ReceivedQuanity, ReceivingQuanity, RemainingQuanity } from './Quantities';

interface ModelDefinitionsProps {
  model: Model;
  isAdjustment: boolean;
  isRMA: boolean;
  processing: boolean;
  receivingQty: number;
  receivedQty: number;
  remainingQty: number;
  tags: MultiselectProps.Option[];
  unExpectedTags: any[];
  setUnExpectedTags: (tags: any[]) => void;
  setTags: Dispatch<SetStateAction<MultiselectProps.Option[]>>;
  selectedCategory: any;
  handleCategoryChange: (selectedCategory: any) => void;
  handleBuildIdChange: (buildId: string) => void;
  buildId?: string;
}

export const ModelDefinitions = ({
  model,
  isAdjustment,
  isRMA,
  processing,
  receivedQty,
  receivingQty,
  remainingQty,
  tags,
  unExpectedTags,
  setUnExpectedTags,
  setTags,
  selectedCategory,
  handleCategoryChange,
  handleBuildIdChange,
  buildId,
}: ModelDefinitionsProps) => {
  const mappedIPN = model?.mappedIPN || '';
  return (
    <SpaceBetween size="l" direction="horizontal">
      <ColumnLayout columns={6} variant="text-grid">
        <MPNIPNDefinition model={model} />
        {model?.receiveExecutionUUId && <MPNExecutionCell model={model} />}
        <APNCellDefinition ipn={mappedIPN} />
        <SpaceBetween size="xxs" direction="horizontal">
          <ColumnLayout columns={6} variant="text-grid">
            {!isAdjustment && !isRMA && (
              <ExpectedReceivedQuanity show={!isAdjustment && !isRMA} model={model} processing={processing} />
            )}
            {isRMA && <ReceivedQuanity count={receivedQty} show={isRMA} />}
            {!isAdjustment && !isRMA && <RemainingQuanity remainingQty={remainingQty} show={!isAdjustment && !isRMA} />}
            <ReceivingQuanity receivingQty={receivingQty} />
            {(isAdjustment || isRMA || !model?.referenceLineItemId) && (
              <BuildCategory
                show={isAdjustment || isRMA || !model?.referenceLineItemId}
                processing={processing}
                selectedCategory={selectedCategory}
                handleCategoryChange={handleCategoryChange}
              />
            )}
            {(isAdjustment || isRMA || !model?.referenceLineItemId) && selectedCategory === 'BUILD' && (
              <BuildIDComponent
                show={(isAdjustment || isRMA || !model?.referenceLineItemId) && selectedCategory === 'BUILD'}
                handleBuildIdChange={handleBuildIdChange}
                buildId={buildId}
                disabled={processing}
              />
            )}
            <Tags
              selectedTags={tags}
              disabled={processing}
              unExpectedTags={unExpectedTags}
              setUnExpectedTagsInContainer={setUnExpectedTags}
              setSelectedTagsInContainer={setTags}
            />
          </ColumnLayout>
        </SpaceBetween>
      </ColumnLayout>
    </SpaceBetween>
  );
};
